"use strict";
import Common from "./Common";
import SplashScene from "./SplashScene";
import GameScene3D from "./GameScene3D";

export default class Application {
    constructor() {

    }

    init() {
        Application.showGameScene3D();
    }

    /**
     * @returns {Scene}
     */
    static showSplashScene() {

        var scene = new SplashScene();

        scene.signals.next.add(function () {
            Application.showGameScene3D();
        }, this);

        Common.scene.show(scene);

        return scene;

    }

    static showGameScene3D() {

        var scene = new GameScene3D();

        scene.signals.next.add(function (scene) {
            Application.showGameScene3D();
        }, this);

        scene.signals.home.add(function (scene) {
            Application.showSplashScene();
        }, this);

        Common.scene.show(scene);

        return scene;
    }
}